/**
 * H3.js
 * Styled Component for H3
 */
import styled from 'styled-components'

// Styles
const Heading3 = styled.h3`
    color: ${props => props.theme.colors.headingColor};  
`

export default Heading3;